"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentFilterDisplayVariant = exports.ContentFilterSortingOption = exports.ContentFilterQueryParamKey = void 0;
var ContentFilterQueryParamKey;
(function (ContentFilterQueryParamKey) {
    ContentFilterQueryParamKey["CATEGORY"] = "category";
    ContentFilterQueryParamKey["TYPE"] = "type";
})(ContentFilterQueryParamKey || (exports.ContentFilterQueryParamKey = ContentFilterQueryParamKey = {}));
var ContentFilterSortingOption;
(function (ContentFilterSortingOption) {
    ContentFilterSortingOption[ContentFilterSortingOption["ALPHABETICAL"] = 1] = "ALPHABETICAL";
    ContentFilterSortingOption[ContentFilterSortingOption["ITEMS_COUNT"] = 2] = "ITEMS_COUNT";
})(ContentFilterSortingOption || (exports.ContentFilterSortingOption = ContentFilterSortingOption = {}));
var ContentFilterDisplayVariant;
(function (ContentFilterDisplayVariant) {
    ContentFilterDisplayVariant[ContentFilterDisplayVariant["HIDE_EXTRA_ITEMS"] = 1] = "HIDE_EXTRA_ITEMS";
    ContentFilterDisplayVariant[ContentFilterDisplayVariant["SHOW_ALL_ITEMS"] = 2] = "SHOW_ALL_ITEMS";
})(ContentFilterDisplayVariant || (exports.ContentFilterDisplayVariant = ContentFilterDisplayVariant = {}));
//# sourceMappingURL=ContentFilters.js.map